// Wake hints only. No request inputs, file paths or authority travel here.
// The worker still polls its authenticated queue and authorizes every request.
const listeners = new Set();
const desktopListeners = new Set();
const remoteListeners = new Set();
let connection = { userId: null, generation: null, connected: false };
const publish = signal => { for (const listener of listeners) { try { listener(signal); } catch { /* one retired consumer must not interrupt socket handlers */ } } };
export const subscribeProjectRequestSignals = listener => { listeners.add(listener); return () => listeners.delete(listener); };
export const projectSignalConnection = () => connection;
export const subscribeDesktopRequestSignals = listener => { desktopListeners.add(listener); return () => desktopListeners.delete(listener); };
export const subscribeRemoteHostSignals = listener => { remoteListeners.add(listener); return () => remoteListeners.delete(listener); };
const publishTo = (targets, signal) => { for (const listener of targets) { try { listener(signal); } catch {} } };

export function attachProjectRequestSignals(socket, { userId, generation, isCurrent }) {
  const status = connected => {
    if (!isCurrent()) return;
    connection = { userId: String(userId), generation, connected };
    publish({ ...connection, type: 'connection' });
    publishTo(desktopListeners, { ...connection, type: 'connection' });
    publishTo(remoteListeners, { ...connection, type: 'connection' });
  };
  socket.on('connect', () => status(true));
  socket.on('disconnect', () => status(false));
  socket.on('connect_error', () => status(false));
  socket.on('project:request-ready', data => {
    if (!isCurrent() || !data || typeof data.deviceId !== 'string' || data.deviceId.length > 100 ||
        typeof data.bindingId !== 'string' || data.bindingId.length > 100) return;
    publish({ type: 'ready', userId: String(userId), generation, deviceId: data.deviceId, bindingId: data.bindingId });
  });
  socket.on('desktop:request-ready', data => {
    if (!isCurrent() || !data || typeof data.deviceId !== 'string' || data.deviceId.length > 100 ||
        typeof data.grantId !== 'string' || data.grantId.length > 100) return;
    publishTo(desktopListeners, { type: 'ready', userId: String(userId), generation, deviceId: data.deviceId });
  });
  socket.on('remote:request-ready', data => {
    if (!isCurrent() || !data || typeof data.hostId !== 'string' || data.hostId.length > 100) return;
    publishTo(remoteListeners, { type: 'ready', userId: String(userId), generation, hostId: data.hostId });
  });
  status(socket.connected === true);
}
